export default __webpack_public_path__ + "static/media/star.e7537821.svg";